export default __webpack_public_path__ + "static/shikshalokam-f786799cdd5b1e4a60fabf1a0dfacc4e.svg";